<!-- 需求提报 -->
<template>
  <div>
    <!-- 搜索 -->
    <div class="container">
      <e-search
          :data="listQuery"
          :field-list="fieldList"
          :list-type-info="listTypeInfo"
          :width="listTypeInfo.width"
          @handleFilter="handleQuery"
          @handleReset="handleReset"
      ></e-search>
    </div>
    <!-- 操作按钮 -->
    <div class="container">
      <eui-btn style="margin-bottom: 10px" type="weak" @click="exportList">导出</eui-btn>
      <eTableList
          :table-data="tableData"
          :table-label="tableLabel"
          :index-show="true"
      >
        <template #handle="{ scope }">
          <span class="table-handle-btn" @click="goPath(scope.row, '/ES/orderQuery/details')">
            查看
          </span>
        </template>
      </eTableList>
      <div class="pagination">
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :pager-count="5"
            :page-sizes="[10, 20, 30]"
            layout="total, sizes, prev, pager, next, jumper"
            :current-page="listQuery.pageNum"
            :total="total"
            :page-size.sync="listQuery.pageSize"
            prev-text="上一页"
            next-text="下一页"
        ></el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
  import eSearch from '@/modules/projectA/components/common/e-search';
  import eTableList from '@/modules/projectA/components/common/e-table-list';
  import Api from '@/modules/projectA/api/ESorganization';
  import {
    tableLabel,
    fieldList,
    listTypeInfo
  } from './components/componentsData.js';
  import utils from '@/modules/projectA/utils/utils';
  import { dateformate } from '../../../utils/utils';

  export default {
    components: { eSearch, eTableList },
    data() {
      return {
        tableLabel,
        fieldList,
        listTypeInfo,
        listQuery: {
          pageNum: 1,
          pageSize: 10,
          applyStatusList: null,
          supplierType: ''
        },
        total: 0,
        cloneListQuery: {},
        tableData: [],
        info: {},
        visible: false
      };
    },
    created() {
      this.cloneListQuery = this.$options.data().listQuery;
      this.getList(this.listQuery);
    },

    methods: {
      // 获取列表数据
      async getList(params) {
        this.tableLoading = true;
        await Api.queryEvaluationAgencyApplyPageList({
          ...params,
          applyStatusList: params.applyStatusList ? params.applyStatusList.split(',') : undefined,
          startTime: params.applyTime ? dateformate(params.applyTime[0], 'yyyy-MM-dd') : undefined,
          endTime: params.applyTime ? dateformate(params.applyTime[1], 'yyyy-MM-dd') : undefined,
          applyTime: undefined
        }).then(res => {
          this.tableLoading = false;
          if (res.code === '200') {
            const data = res.data;
            this.tableData = [...data?.records];
            this.total = data?.total;
          }
        });
      },
      /**
       * 导出
       */
      exportList() {
        Api.exportAgencyApplyOrder({
          ...this.listQuery,
          applyStatusList: this.listQuery.applyStatusList ? this.listQuery.applyStatusList.split(',') : undefined,
          startTime: this.listQuery.applyTime ? dateformate(this.listQuery.applyTime[0], 'yyyy-MM-dd') : undefined,
          endTime: this.listQuery.applyTime ? dateformate(this.listQuery.applyTime[1], 'yyyy-MM-dd') : undefined,
          applyTime: undefined,
          pageNum: undefined,
          pageSize: undefined
        }).then((res) => {
          if (res.type === 'application/json') {
            utils.fileExportResponseError(res);
          } else {
            utils.downFile(res);
          }
        });
      },
      // 更改页码
      handleCurrentChange(val) {
        this.listQuery.pageNum = val;
        this.getList(this.listQuery);
      },

      // 更改条数
      handleSizeChange(val) {
        this.listQuery.pageNum = 1;
        this.listQuery.pageSize = val;
        this.getList(this.listQuery);
      },

      // 重置
      handleReset() {
        this.listQuery = { ...this.cloneListQuery };
        this.getList(this.listQuery);
      },

      // 搜索
      handleQuery(val) {
        this.listQuery = { ...val, pageNum: 1 };
        this.getList(this.listQuery);
      },
      goPath(row, path) {
        const { applyId, applyStatus } = row;
        this.$router.push({
          path,
          query: {
            applyId,
            applyStatus
          }
        });
      }
    },
    mounted() {
    }
  };
</script>
<style lang="scss" scoped>
  @import '@/assets/css/theme.scss';

  .theme {
    color: $main-col;
    cursor: pointer;
  }

  .table-handle-btn + .table-handle-btn {
    margin-left: 10px;
  }
</style>
